<template>
  <div class="container">
    <div class="extract">
      <div class="deposit">提现金额</div>
      <div class="money van-hairline--bottom">
        <span class="symbol">￥</span>
        <span class="number">{{exMoney}}</span>
      </div>
      <div class="bank">
        <div style="color:#666666">银行收取手续费</div>
        <div>￥1.00</div>
      </div>
    </div>
    <div class="box">
      <div class="yardage">
        <span>接收验证码</span>
        <span class="phone">{{$route.params.phone}}</span>
      </div>
      <div class="verification">请输入短信验证码以确认身份</div>
      <van-button
        class="send hairline"
        plain
        color="#208FFF"
        @click="getWithdrawSmsCode"
        :disabled="disabled"
      >{{verifyCode}}</van-button>
    </div>
    <div class="code">
      <input
        ref="pwd"
        type="number"
        maxlength="6"
        v-model="value"
        unselectable="on"
        style="opacity: 0"
        @input="inputChange"
      />
      <ul
        class="pwd-wrap"
        @click="focus"
      >
        <li
          v-for="(item,index) in 6"
          :key="index"
          class="van-hairline--surround"
          :class="{'psd-blink':value.length==index&&show}"
        >{{value.slice(index,index+1)}}</li>
      </ul>
      <p
        class="tips"
        :style="{'visibility':showTips?'visible':'hidden'}"
      >
        <img
          src="../../assets/img/send.png"
          alt
        />验证码已发送，可能会有延迟，2分钟内有效
      </p>
    </div>
    <van-button
      class="btn"
      text="提交"
      :disabled="value.length!=6 || showCodeError"
      @click="submit"
    />
    <div
      class="codeError"
      v-if="showCodeError"
    >输入验证码错误次数太多，{{minute}}分钟后再操作</div>
  </div>
</template>
<script>
import { getWithdrawSmsCode, putWithdrawSmsCode, getOperateFailMsg } from "@/api/join";
export default {
  data() {
    return {
      verifyCode: "发送验证码",
      disabled: false,
      value: "", //验证码
      show: false,
      obj: {},
      exMoney: "", //提现金额
      showTips: false,
      minute: "",
      showCodeError: false,
    };
  },
  mounted() {
    this.exMoney = this.$route.params.exMoney;
    this.getOperateFailMsg();
  },
  methods: {
    inputChange() {
      this.value = this.value.replace(/[^\d]/g, "");
      if(this.value.length>6)this.value=this.value.slice(0,6);
    },
    focus() {
      this.show = true;
      this.$refs.pwd.focus();
    },
    sendCodeError(i) {
      i = i - 1;
      this.minute = parseInt(i / 60);
      if (i == 0) {
        this.showCodeError = false;
        this.disabled = false;
        return;
      }
      setTimeout(() => {
        this.sendCodeError(i);
      }, 1000);
    },
    sendCode(i) {
      //发送验证码
      i = i - 1;
      this.verifyCode = i + "S";
      if (i == 0) {
        this.verifyCode = "重新发送";
        this.disabled = false;
        return;
      }
      setTimeout(() => {
        this.sendCode(i);
      }, 1000);
    },
    getWithdrawSmsCode() {
      getWithdrawSmsCode({
        tranAmount: this.exMoney, //申请提现金额
        acctId: this.$route.params.acctId,
      }).then((res) => {
        if (res.appStatus.errorCode == 0) {
          this.disabled = true;
          this.sendCode(60);
          this.showTips = true;
        }
      });
    },
    putWithdrawSmsCode() {
      putWithdrawSmsCode({
        tranAmount: this.exMoney, //申请提现金额(后台计算手续费)
        code: this.value, //短信验证码
        cardId: this.$route.params.cardId,
      }).then((res) => {
        if (res.appStatus.errorCode == 0) {
          this.$router.push({
            name: "withdrawSuccess",
            path: "/withdrawSuccess",
            params: {
              info: JSON.stringify(res.content),
            },
          });
        } else if (res.appStatus.errorCode == 4224) {
          this.getOperateFailMsg();
        }
      });
    },
    getOperateFailMsg() {
      getOperateFailMsg({
        userTpye: "1", //会员角色 1:买家、2:卖家、3:厂家、4:选菜师、5:菜老板助手 6城市合伙人
        verifyType: "1", // 认证类型 1.提现 2.绑卡
      }).then((res) => {
        if (res.appStatus.errorCode == 0) {
          if (res.content.errNum >= 3) {
            this.disabled = true;
            this.showCodeError = true;
            this.sendCodeError(res.content.tryTime);
          }
        }
      });
    },
    submit() {
      if (!this.showTips) {
        this.$toast("您未发送验证码");
        return;
      }
      this.putWithdrawSmsCode();
    },
  },
};
</script>
<style lang="scss" scoped>
.box {
  height: 72px;
  line-height: 36px;
  padding: 15px 12px;
  background-color: #fff;
  position: relative;
  .yardage {
    font-size: 16px;
    .phone {
      font-size: 20px;
      font-weight: bold;
      padding-left: 10px;
    }
  }
  .verification {
    font-size: 16px;
  }
  .send {
    position: absolute;
    top: 34px;
    right: 16px;
    width: 89px;
    height: 34px;
    padding: 0;
    font-size: 14px;
    border-radius: 10px;
  }
  .send.van-button--disabled {
    color: #999999 !important;
    border-color: #999999 !important;
    opacity: 1;
  }
}
.btn {
  height: 40px;
  margin: 50px 12px 0;
  font-size: 16px;
  color: #ffffff;
  background-color: #50BE4C;
  border-radius: 50px;
}
.btn.van-button--disabled {
  background-color: #cccccc;
  opacity: 1;
}
.extract {
  background-color: #fff;
  padding-top: 17px;
  margin: 0 0 10px 0;
  text-align: center;
  .deposit {
    font-size: 15px;
  }
  .money {
    margin: 10px 16px 0;
    padding-bottom: 14px;
    font-weight: bold;
    .symbol {
      font-size: 30px;
    }
    .number {
      font-size: 45px;
    }
  }
  .bank {
    display: flex;
    justify-content: space-between;
    padding: 12px 15px 21px;
    font-size: 15px;
  }
}
.code {
  width: 343px;
  padding: 0 16px;
  background-color: #fff;
  .pwd-wrap {
    display: flex;
    justify-content: space-between;
    background-color: #fff;
    .psd-blink[class*="van-hairline"]::after {
      border-color: #ff1310;
    }
    li {
      width: 52px;
      height: 52px;
      line-height: 52px;
      display: inline-block;
      font-size: 39px;
      font-weight: 800;
      color: #333333;
      text-align: center;
      list-style-type: none;
    }
    [class*="van-hairline"]::after {
      border-radius: 5px;
    }
  }
  .tips {
    height: 53px;
    line-height: 53px;
    font-size: 12px;
    color: #666666;
    display: flex;
    align-items: center;
    img {
      width: 13px;
      height: 13px;
      margin-right: 5px;
    }
  }
}
.codeError {
  margin: 12px 16px 0;
  font-size: 15px;
  color: #666666;
}
</style>